import { render, staticRenderFns } from "./DMSAlertSettings.vue?vue&type=template&id=e87c8e3c&scoped=true"
import script from "./DMSAlertSettings.vue?vue&type=script&lang=js"
export * from "./DMSAlertSettings.vue?vue&type=script&lang=js"
import style0 from "./DMSAlertSettings.vue?vue&type=style&index=0&id=e87c8e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87c8e3c",
  null
  
)

export default component.exports